var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 18,
    viewBox: "0 0 95 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57812 0.992188L10.3804 6.53895L16.2126 6.53895L11.4942 9.96703L13.2965 15.5138L8.57812 12.0857L3.85977 15.5138L5.66202 9.96703L0.943667 6.53895L6.77587 6.53895L8.57812 0.992188Z",
    fill: "#FF7272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9531 0.992188L29.7554 6.53895L35.5876 6.53895L30.8692 9.96703L32.6715 15.5138L27.9531 12.0857L23.2348 15.5138L25.037 9.96703L20.3187 6.53895L26.1509 6.53895L27.9531 0.992188Z",
    fill: "#FF7272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3262 0.992188L49.1284 6.53895L54.9606 6.53895L50.2423 9.96703L52.0445 15.5138L47.3262 12.0857L42.6078 15.5138L44.4101 9.96703L39.6917 6.53895L45.5239 6.53895L47.3262 0.992188Z",
    fill: "#FF7272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6992 0.992188L68.5015 6.53895L74.3337 6.53895L69.6153 9.96703L71.4176 15.5138L66.6992 12.0857L61.9809 15.5138L63.7831 9.96703L59.0648 6.53895L64.897 6.53895L66.6992 0.992188Z",
    fill: "#FF7272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0742 0.992188L87.8765 6.53895L93.7087 6.53895L88.9903 9.96703L90.7926 15.5138L86.0742 12.0857L81.3559 15.5138L83.1581 9.96703L78.4398 6.53895L84.272 6.53895L86.0742 0.992188Z",
    fill: "#B7B7B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStar);
export default __webpack_public_path__ + "static/media/product-star.e8db2da4a5d64267d6bdda57cf9faf39.svg";
export { ForwardRef as ReactComponent };